import * as React from 'react'
import { Route, RouteComponentProps, RouteProps, Switch } from 'react-router-dom'
import TableDriversPane from '../../containers/drivers/TableDriversPane'
import CreateDriver from '../../containers/drivers/CreateDrivers'
import DriverView from '../../containers/drivers/DriverView'
import DriverEdit from '../../containers/drivers/DriverEdit'
import AssignOperatorVehicle from 'src/containers/drivers/AssignOperatorVehicle'
import ErrorBoundary from '../ErrorBoundary'

interface IDriversPaneProps {
  organizationId: string
  routeProps: RouteComponentProps<any>
  onComponentMount: (organizationId: string) => void
}

class DriversPane extends React.Component<IDriversPaneProps> {
  public componentDidMount() {
    this.props.onComponentMount(this.props.organizationId)
  }

  public render() {
    return (
      <section className='Drivers fit-height'>
        <div className='TripControls bg-white fit-height'>
          <ErrorBoundary>
            <Switch>
              <Route path={`${this.props.routeProps.match.path}/`} exact={true} component={TableDriversPane} />
              <Route path={`${this.props.routeProps.match.path}/create`} component={CreateDriver} />
              <Route path={`${this.props.routeProps.match.path}/:id/edit`} component={DriverEditWrapper} />
              <Route
                path={`${this.props.routeProps.match.path}/:operatorId/assign-vehicle`}
                component={AssignOperatorVehicle}
              />
              <Route path={`${this.props.routeProps.match.path}/:id`} component={DriverView} />
            </Switch>
          </ErrorBoundary>
        </div>
      </section>
    )
  }
}

const DriverEditWrapper = (props: RouteComponentProps<any>) => (
  <DriverEdit driverId={props.match.params.id} routeProps={props} />
)

export default DriversPane



// WEBPACK FOOTER //
// ./src/components/drivers/DriversPane.tsx